var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadCircuitActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_650_1095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12.5C14.9067 12.5 14.3266 12.3241 13.8333 11.9944C13.3399 11.6648 12.9554 11.1962 12.7284 10.6481C12.5013 10.0999 12.4419 9.49667 12.5576 8.91473C12.6734 8.33279 12.9591 7.79824 13.3787 7.37868C13.7982 6.95912 14.3328 6.6734 14.9147 6.55765C15.4967 6.44189 16.0999 6.5013 16.6481 6.72836C17.1962 6.95543 17.6648 7.33994 17.9944 7.83329C18.3241 8.32664 18.5 8.90666 18.5 9.5C18.5 10.2957 18.1839 11.0587 17.6213 11.6213C17.0587 12.1839 16.2957 12.5 15.5 12.5Z",
    fill: "#A68AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 20C17.4067 20 16.8266 19.8241 16.3333 19.4944C15.8399 19.1648 15.4554 18.6962 15.2284 18.1481C15.0013 17.5999 14.9419 16.9967 15.0576 16.4147C15.1734 15.8328 15.4591 15.2982 15.8787 14.8787C16.2982 14.4591 16.8328 14.1734 17.4147 14.0576C17.9967 13.9419 18.5999 14.0013 19.1481 14.2284C19.6962 14.4554 20.1648 14.8399 20.4944 15.3333C20.8241 15.8266 21 16.4067 21 17C21 17.7957 20.6839 18.5587 20.1213 19.1213C19.5587 19.6839 18.7957 20 18 20Z",
    fill: "#A68AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 27H8.99992C8.7347 27 8.48034 26.8946 8.29281 26.7071C8.10527 26.5196 7.99992 26.2652 7.99992 26V21.4763L4.55241 19.8975C4.32462 19.7833 4.149 19.5865 4.06142 19.3472C3.97383 19.1079 3.9809 18.8443 4.08117 18.61L6.99992 13C6.99992 11.2954 7.43563 9.61916 8.2657 8.13036C9.09576 6.64155 10.2926 5.38964 11.7426 4.49349C13.1926 3.59735 14.8476 3.08673 16.5504 3.01011C18.2533 2.93349 19.9474 3.29342 21.472 4.05573C22.9967 4.81803 24.3011 5.95741 25.2615 7.36565C26.2219 8.7739 26.8064 10.4043 26.9595 12.1019C27.1126 13.7996 26.8292 15.5083 26.1362 17.0656C25.4432 18.6229 24.3636 19.9773 22.9999 21L23.9999 29",
    stroke: "#A68AFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7975 11H23L18 17",
    stroke: "#A68AFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9.5V3.11125",
    stroke: "#A68AFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_650_1095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadCircuitActive);
export default __webpack_public_path__ + "static/media/HeadCircuitActive.b77f4d06d5a9b11f86062383ba9d8502.svg";
export { ForwardRef as ReactComponent };